import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { lastValueFrom, Observable } from 'rxjs';
import { TeamMembership, UpdatePasswordRequest, UserEntity } from '../../models/entities/user-entity';
import { User } from '../../models/home/sign-up';
import { CustomerEnquiryForm } from '../../models/home/customer-enquiry-form';
import { Log, IShortLogger } from '../logger.service';

@Injectable({
  providedIn: 'root'
})
export class UserEntityService {
  private readonly logger: IShortLogger<UserEntityService> = Log.create(UserEntityService);
  public baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) {
  }

  getAllUsers(): Observable<any> {

    var res = this.http.get(`${this.baseUrl}/v1/users`);
    return res;
  }

  userGetByUserId(): Observable<any> {

    var userId = localStorage.getItem('userId');
    var res = this.http.get(`${this.baseUrl}/v1/users/${userId}`);
    return res;
  }

  getMasterData(): Observable<any> {

    var res = this.http.get(`${this.baseUrl}/v1/users/masterdata`);
    return res;
  }

  async createUser(user: UserEntity): Promise<UserEntity> {

    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(user);

    this.logger.i("Creating User with body: ", body);
    let created = await lastValueFrom(this.http.post(`${this.baseUrl}/v1/users`, body, { headers }));
    return created as UserEntity;
  }

  updateUser(user: UserEntity): Observable<any> {
    const headers = { "content-type": "application/json" };

    const body = JSON.stringify(user);

    this.logger.i("Updating User with body: ", body);
    this.logger.i("User ID: ", user.id);
    this.logger.i("PUT URL: ", `${this.baseUrl}/v1/users/${user.id}`);
    this.logger.i("Headers: ", headers);
    return this.http.put(`${this.baseUrl}/v1/users/${user.id}`, body, { headers });

  }

  deleteUsers(userIds: string[]): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify({ userIds });
    return this.http.post(`${this.baseUrl}/v1/users/delete`, body, { headers });
  }

  checkRights(userId: string, businessProcessName: string, activity: string, actionName: string): Observable<any> {

    // var userId = localStorage.getItem('userId');
    return this.http.get(`${this.baseUrl}/v1/users/checkRights/${userId}/${businessProcessName}/${activity}/${actionName}`);

  }

  rightsCasesGetByUserId(userId: string, rightsCases: any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(rightsCases);
    return this.http.post(`${this.baseUrl}/v1/users/rightsCasesGetByUserId/${userId}`, body, { headers });

  }


  updatePassword(passwordData: UpdatePasswordRequest): Observable<any> {
    this.logger.d("password data service.ts :: ", passwordData);

    return this.http.patch(`${this.baseUrl}/v1/users/update-password`, passwordData);
  }

  /**
   * Adds a user to a team
   */
  addTeamMembership(userId: string, teamId: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/v1/users/${userId}/teams/${teamId}`, {});
  }

  /**
   * Removes a user from a team
   */
  removeTeamMembership(userId: string, teamId: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/v1/users/${userId}/teams/${teamId}`);
  }

  /**
   * Sets a team as the user's primary team
   */
  setPrimaryTeam(userId: string, teamId: string): Observable<any> {
    return this.http.patch(`${this.baseUrl}/v1/users/${userId}/teams/${teamId}/set-primary`, {});
  }

  /**
   * Gets all team memberships for a user
   */
  getUserTeams(userId: string): Observable<TeamMembership[]> {
    return this.http.get<TeamMembership[]>(`${this.baseUrl}/v1/users/${userId}/teams`);
  }
}
